import { TwoAppFieldMapping, WorkflowTaskV2 } from "@/types/WorkflowCreate/workflowCreate"
import { showWorkflowErrorNotification } from "./formValidationNotification"
import { SelectedFilterAndOption } from "@/types/workflow"
import { App } from "@/types/applications"
import { AppName } from "@/constants/application/application"

export const isValidSourceId = (
  dataSourceId: string | undefined,
) => {
  if (!dataSourceId || dataSourceId?.length === 0) {
    showWorkflowErrorNotification('The App you selected in Step 1 is invalid or it is not supported yet.')
    return false
  }
  return true
}

export const isValidActionsSubjectsAndCredentials = (
  tasks: WorkflowTaskV2[],
  apps: App[]
) => {
  const errors: string[] = []

  if (!tasks || tasks.length === 0) {
    return false
  }

  tasks.forEach((task, index) => {
    const app = apps.find(a => a.id === task.appId)
    if (app) {
      const hasValidAction = task.action.length > 0
      if (!hasValidAction) {
        errors.push(`Action is invalid for ${app.displayName}, Step ${index + 1}`)
      }
      const isValidSubject = task.subject.length > 0
      if (!isValidSubject) {
        errors.push(`Subject is invalid for ${app.displayName}, Step ${index + 1}`)
      }
    }
    if (task.credentialIds.find(c => c.length === 0)) {
      errors.push(`Credential not selected for Step ${index + 1}`)
    }
  })

  if (errors.length) {
    showWorkflowErrorNotification(errors.join(', '))
    return false
  }

  return true
}

export const hasAllFiltersSelected = (
  selectedFilters: SelectedFilterAndOption[],
  appName: string
) => {
  if (selectedFilters.length === 0) {
    showWorkflowErrorNotification(`Incomplete filters for: ${appName}`)
    return false
  }

  return true
}

export const hasValidApplications = (
  tasks: WorkflowTaskV2[],
  applications?: App[]
) => {
  // We are allowing to create workflow if it has only one task with TCS_CUSTOM app
  if (applications?.find(a => a.id === tasks[0].appId)?.name === AppName.TCS_CUSTOM) {
    return true
  }
  if (tasks.length <= 1) {
    showWorkflowErrorNotification('Please add at least one more application to create a workflow.')
    return false
  }
  return true
}

export const hasValidFieldMappings = (
  fieldMappings: TwoAppFieldMapping[],
  applications: App[]
) => {
  const errors: string[] = []

  fieldMappings.forEach(sourceToDestination => {
    const app = applications.find(app => app.id === sourceToDestination.destinationAppId)
    if (!sourceToDestination.mappings) {
      errors.push(`Field Mapping not selected for ${app?.displayName}`)
      return false
    }
  })

  if (errors.length) {
    showWorkflowErrorNotification(errors.join(', '))
    return false
  }

  return errors.length === 0
}

export const hasDestinationCredentials = (
  credentials: string[]
) => {
  if (credentials.length === 0) {
    showWorkflowErrorNotification('Credentials are missing in at least one destination.')
    return false
  }
  for (const cred of credentials) {
    if (cred.length === 0) {
      showWorkflowErrorNotification('Credentials are missing in at least one destination.')
      return false
    }
  }
  return true
}
